import React from 'react';

import { useFormik } from 'formik';
import { FaSearch } from 'react-icons/fa';
import { useHistory, useParams } from 'react-router-dom';

import { FormInput, Button } from 'modules/common/input';
import PageTitle from 'modules/common/components/PageTitle';
import ErrorLabel from 'modules/common/components/ErrorLabel';

import { useValidateOrder } from '../hooks';
import Brand from '../../partial/components/Brand';
import InfoGraphic from '../components/InfoGraphic';
import { validateOrderSchema } from '../validations';

const INIT_FORM = {
  order_number: '',
};

function ValidateOrder() {
  const history = useHistory();
  const { order_number } = useParams();
  const [isApiLoading, validate] = useValidateOrder();
  const [validation, setValidation] = React.useState(false);

  const { handleSubmit, setFieldValue, values, errors } = useFormik({
    initialValues: {
      ...INIT_FORM,
      order_number: order_number || '',
    },
    enableReinitialize: true,
    validationSchema: validateOrderSchema,
    validateOnChange: validation,
    validateOnBlur: validation,
    onSubmit: (form) => {
      const $order_number = form?.order_number;
      const x = $order_number.replace(/\s/g, '');
      validate(x, (status) => {
        if (status === 'FOR_PICKUP' || status === 'IN_TRANSIT')
          history.push(`/r/otp?order_number=${x}`);
      });
    },
  });

  return (
    <>
      <PageTitle title="PEP | Validate Order" />
      <div className="h-full">
        <div className="flex h-full px-3">
          <div className="m-auto mb-10">
            <div className="flex justify-center">
              <Brand className="h-8" />
            </div>
            <div className="text-center mt-10 md:mt-14">
              <h4 className="text-2xl md:text-3xl font-bold">
                Rider Tracking Order
              </h4>
              <p className="text-gray-500 text-sm">
                Please enter customer order number
              </p>
            </div>
            <form
              className="mt-10 relative"
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit();
                setValidation(true);
              }}
              noValidate
            >
              <div className="relative z-10">
                <FormInput
                  label={false}
                  name="order_number"
                  prefix={<FaSearch />}
                  placeholder="Enter Order Number"
                  onSetFieldValue={setFieldValue}
                  value={values?.order_number || ''}
                />
                <div className="absolute right-0 top-0 h-full flex items-center mr-2">
                  <Button
                    withLoader
                    type="submit"
                    label="Track Order"
                    disabled={isApiLoading}
                    isLoading={isApiLoading}
                    className="btn sm primary font-medium"
                  />
                </div>
              </div>
              <div className="mt-3">
                <ErrorLabel error={errors?.order_number} />
              </div>
            </form>
            <InfoGraphic />
          </div>
        </div>
      </div>
    </>
  );
}
ValidateOrder.defaultProps = {};

ValidateOrder.propTypes = {};

export default ValidateOrder;
